/** Policy tabs: switch + anchor + Theme Editor reload (no equalized min-height). **/
(function () {
  function bindPolicyBannerAnchors(root) {
    root.querySelectorAll(".policy-banner-anchor").forEach((el) => {
      if (el.dataset.policyAnchorBound) return;
      el.dataset.policyAnchorBound = "1";
      el.addEventListener("click", (e) => {
        const href = el.getAttribute("href") || "";
        if (!href.startsWith("#") || href === "#") return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function centerTitleInHeader(title) {
    const header = title.closest(".policy-tabs-header");
    if (!header) return;
    const targetScrollLeft =
      title.offsetLeft + title.offsetWidth / 2 - header.clientWidth / 2;
    const maxScrollLeft = header.scrollWidth - header.clientWidth;
    header.scrollTo({
      left: Math.max(0, Math.min(targetScrollLeft, maxScrollLeft)),
      behavior: "smooth",
    });
  }

  function initPolicyTabs(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll
      ? scope.querySelectorAll(".policy-tabs-section")
      : [];
    const list =
      scope.classList && scope.classList.contains("policy-tabs-section")
        ? [scope]
        : Array.from(sections);

    list.forEach((section) => {
      if (section.dataset.policyTabsReady === "1") return;
      section.dataset.policyTabsReady = "1";

      const body = section.querySelector(".policy-tabs-body");
      if (body) {
        // Clear legacy equalized height from prior builds
        body.style.minHeight = "";
      }

      section.querySelectorAll(".policy-tab-title").forEach((title) => {
        title.addEventListener("click", () => {
          title.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
          centerTitleInHeader(title);
          const targetId = title.getAttribute("data-tab-target");
          const container = title.closest(".policy-tabs-section");
          if (!targetId || !container) return;

          container.querySelectorAll(".policy-tab-title").forEach((t) => {
            t.classList.remove("active");
          });
          title.classList.add("active");

          container.querySelectorAll(".policy-tab-content").forEach((c) => {
            c.classList.remove("active");
          });
          const targetContent = container.querySelector("#" + CSS.escape(targetId));
          if (targetContent) targetContent.classList.add("active");
        });
      });

      bindPolicyBannerAnchors(section);
    });
  }

  window.initPolicyTabs = initPolicyTabs;

  document.addEventListener("DOMContentLoaded", () => initPolicyTabs(document));
  document.addEventListener("shopify:section:load", (e) => {
    if (e && e.target) {
      e.target.querySelectorAll(".policy-tabs-section").forEach((section) => {
        delete section.dataset.policyTabsReady;
      });
      initPolicyTabs(e.target);
    }
  });
})();
